module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a1Arg"))).then(() => module.bundle.root('cvs7o'));